/** Shared number formatting for ranking card rows and livestream table. */
export function formatMetric(
  value: number,
  metric:
    | "views"
    | "interactions"
    | "programs-brands"
    | "channels-social"
    | "livestream-avg",
): string {
  const rounded = Math.round(value);
  const withComma = (n: number, decimals: number) => {
    const r = Math.round(n * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return r === Math.round(r)
      ? String(Math.round(r))
      : r.toFixed(decimals).replace(".", ",");
  };
  if (metric === "programs-brands") {
    return value >= 10 ? `${rounded} marcas` : `${withComma(value, 1)} marcas`;
  }
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1).replace(".", ",")}M`;
  }
  if (value >= 10_000) {
    return `${Math.round(value / 1_000)}K`;
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1).replace(".", ",")}K`;
  }
  if (value >= 1) {
    return value >= 10 ? String(rounded) : withComma(value, 1);
  }
  return String(rounded);
}
